<i-tabler [name]="iconName" [class]="iconClass" [ngStyle]="styleMap" >
</i-tabler>